module.exports = __webpack_public_path__ + "img/jr1_mb.c2025d4b.jpg";